import { IconSave } from "@/assets/icons";
import { DetailFooterShell } from "@/components/commons/DetailFooterShell";
import { Button } from "@/components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { Stack } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

export const UserSettingEditFooter: FC = () => {
  const navigate = useNavigate();

  return (
    <DetailFooterShell>
      <Button variant="ghost" size="sm" type="button" onClick={() => navigate(AppRoutes.userSettingDetail)}>
        戻る
      </Button>
      <Button variant="primary" size="sm" sx={{ width: "88px" }} type="submit">
        <Stack direction="row" alignItems="center" gap="8px">
          <IconSave fontSize={20} />
          保存
        </Stack>
      </Button>
    </DetailFooterShell>
  );
};
